<template>
  <div class="login-container">
    <div class="hyy">Welcome</div>
    <div class="login-block">
      <div class="title">
        <div>HQS</div>
        <div style="border-top: 1px solid #606266; padding-top: 2px">
          AUTOMOTIVE
        </div>
      </div>
      <el-form
        :model="loginForm"
        :rules="loginRules"
        ref="loginForm"
        class="login-form"
        @keyup.enter.native="onLogin"
        label-width="100px"
      >
        <el-form-item label="Account" prop="userName">
          <el-input
            placeholder="UserName"
            v-model="loginForm.userName"
            autocomplete="off"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="Password" prop="password">
          <el-input
            placeholder="Password"
            type="password"
            v-model="loginForm.password"
            autocomplete="off"
          >
          </el-input>
        </el-form-item>
        <el-button
          class="login-form-submit"
          @click="onLogin"
          type="primary"
          :loading="isLogin"
          >{{ isLogin ? "Logging in..." : "Login" }}</el-button
        >
      </el-form>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import objurl from "@/common/interface/url.js";
import objaxios from "axios";
import objstorage from "@/common/localstorage/storage.js";
export default {
  name: "",
  //import引入的组件需要注入到对象中才能使用
  components: {},
  //组件参数
  props: {},
  //这里存放数据
  data() {
    return {
      isLogin: false,
      loginForm: {
        userName: "",
        password: "",
      },
      // 验证规则
      loginRules: {
        userName: [
          {
            required: true,
            trigger: "blur",
            message: "The username cannot be empty",
          },
        ],
        password: [
          {
            required: true,
            trigger: "blur",
            message: "Password cannot be empty",
          },
        ],
      },
    };
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    //调试用账号密码，发布需注释
    // this.loginForm.userName = "Xinquan";
    // this.loginForm.password = "string";

   //   this.loginForm.userName = "nevada@tesla.com";
  //  this.loginForm.password = "zavpVWAf";
  // this.loginForm.userName = "QI@TESLA.com";
  //   this.loginForm.password = "sVYPiE8n";
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  //生命周期 - 销毁之前
  beforeDestroy() {},
  //方法集合
  methods: {
    onLogin() {
      var _this = this;

      objaxios.defaults.headers.common["Authorization"] =""
      objaxios
        .post(objurl.user_login, {
          username: this.loginForm.userName,
          password: this.loginForm.password,
        })
        .then(function (res) {
          if (res.data.code == 200) {
            try {
              objstorage.set("userinfo", res.data.data);
              _this.$router.replace("/index-pc");
            } catch (e) {
              // error
            }
          } else {
            _this.$message.error(res.data.message);
            _this.getCodeImage();
          }
        })
        .catch(function (error) {
          console.log(error);
        });


    },
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.login-container {
  height: 100%;
  width: 100%;
  display: flex;

  .hyy {
    width: 50%;
    background: rgba(42, 64, 98, 0.9);
    color: #fff;
    font-size: 2.2em;
    font-weight: 800;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .login-block {
    width: 50%;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .title {
      color: rgb(39, 60, 94);
      font-size: 1.5em;
      font-size: 700;
      margin-bottom: 60px;
    }

    .login-form-title {
      display: flex;
      justify-content: center;
      font-size: 32px;
      font-weight: 800;
      color: #333333;
      margin-bottom: 40px;
    }

    .el-form-item__label {
      text-align: left;
    }

    .el-input__prefix {
      display: flex;
      align-items: center;
    }

    .login-form {
      width: 50%;
      justify-content: center;
      align-items: center;

      .el-form-item {
        width: 100%;
        height: 50px;

        &:not(:first-of-type) {
          margin-top: 20px;
        }

        .el-form-item__content {
          height: 100%;
          display: flex;
          align-items: center;
        }

        .el-input {
          flex: 1;
          height: 100%;

          input {
            border-radius: 3px;
            height: 100%;
            font-size: 16px !important;
          }
        }
      }

      .login-form-submit {
        margin-top: 40px;
        user-select: none;
        width: 100%;
        height: 45px;
        border-radius: 3px;
        background: rgba(42, 64, 98, 0.9);
        text-align: center;
        border: none !important;
      }
    }
  }

  .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue